import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  AlertCircle,
  BarChart2,
  BellRing,
  Book,
  Building,
  Building2,
  Calendar,
  ChevronLeft,
  ChevronRight,
  Copy,
  Copyright,
  Edit,
  Edit2,
  Filter,
  Folders,
  Forward,
  Hash,
  HelpCircle,
  Home,
  Landmark,
  LayoutDashboard,
  LogOut,
  LucideAngularModule,
  Mail,
  MapPin,
  Menu,
  MessageCircle,
  Network,
  Pin,
  PinOff,
  PlusCircle,
  Radio,
  RefreshCw,
  Reply,
  Send,
  Settings,
  Shield,
  ShieldCheck,
  ShieldX,
  SortAsc,
  SortDesc,
  Table,
  Trash,
  Upload,
  User,
  Users,
  X,
  Languages,
  Sun,
  CheckCheck,
  SquareStack,
  Cake,
  FilePenLine,
  CircleCheck,
  File,
  UserCog,
  FileText,
  PanelRight,
  EllipsisVertical,
  Check,
  UserPlus,
  Music,
  Image,
  Clock,
  Megaphone,
  BellOff,
  Info,
  MessageSquareMore,
  BookText,
  Video,
} from 'lucide-angular';
import { TuiIcon } from '@taiga-ui/core';
import { TUI_SANITIZER } from '@taiga-ui/legacy';
import { TuiAvatar } from '@taiga-ui/kit';
import { NgDompurifySanitizer } from '@taiga-ui/dompurify';

import { IconComponent } from './icon.component';

@NgModule({
  declarations: [IconComponent],
  imports: [
    CommonModule,
    TuiIcon,
    TuiAvatar,
    LucideAngularModule.pick({
      AlertCircle,
      BellRing,
      BarChart2,
      Building,
      Building2,
      Calendar,
      ChevronLeft,
      ChevronRight,
      Copy,
      Copyright,
      Edit,
      Edit2,
      Filter,
      Folders,
      Forward,
      Hash,
      HelpCircle,
      Home,
      Landmark,
      LayoutDashboard,
      LogOut,
      Mail,
      MapPin,
      Menu,
      MessageCircle,
      Network,
      Pin,
      PinOff,
      PlusCircle,
      Radio,
      RefreshCw,
      Reply,
      Send,
      Settings,
      Shield,
      ShieldCheck,
      ShieldX,
      SortAsc,
      SortDesc,
      Trash,
      User,
      Users,
      X,
      Table,
      Book,
      BookText,
      Upload,
      Languages,
      Sun,
      CheckCheck,
      SquareStack,
      Cake,
      FilePenLine,
      CircleCheck,
      File,
      UserCog,
      FileText,
      PanelRight,
      EllipsisVertical,
      Check,
      UserPlus,
      Music,
      Image,
      Clock,
      Megaphone,
      BellOff,
      Info,
      MessageSquareMore,
      Video,
    }),
  ],
  providers: [{ provide: TUI_SANITIZER, useClass: NgDompurifySanitizer }],
  exports: [IconComponent, LucideAngularModule],
})
export class IconModule {}
